import * as React from "react";
const SvgBatteryVertical75Percent20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M13 2V0H7v2H4v18h12V2h-3ZM6 18h8V4H6v14Zm1-1V8h6v9H7Z",
      clipRule: "evenodd"
    })
  );
export default SvgBatteryVertical75Percent20Px;
